/* ============
 * State of the auth module
 * ============
 *
 * The initial state of the auth module.
 */

export default {
  contracts: [],
  companySeq: 0,
  contractDownload: false,
};
